import React, { useEffect, useRef, useState, createContext, useReducer } from 'react';
import firebase from 'firebase';
import get from 'lodash/get';
import { CustomControl } from './Boundary';
import { uuidv4 } from './ImportControl';

export const AppContext = createContext();


const sideBarReducer = (state, action) => {

  if (action.type === 'toggleBigRightBar') {
    return {...state, bigRightBar: !state.bigRightBar};
  }
  else if (action.type === 'toggleShowing') {
    const { key, val } = action;

    let togVal = val;
    if (val !== undefined) togVal = !get(state.showing, key);

    // turn off all the sections that takes up the whole sidebar if you are turning another on
    const wholeBarOptions = {
      'FKD': false,
      'Properties': false,
      'County Stats': false,
      'Crop History': false,
    };

    const wholeBarOptionsIf = togVal ? wholeBarOptions : {};

    const showing = {...state.showing, ...wholeBarOptionsIf, [key]: togVal};

    // let bigRightBar = state.bigRightBar;
    // if (togVal && (key in wholeBarOptions)) bigRightBar = true;
    // if (!togVal && (key in wholeBarOptions)) bigRightBar = false;

    // return {...state, bigRightBar, showing};
    return {...state, showing};
  }
}

const getYearsAgo = (n) => {
    var dt = new Date();
    dt.setFullYear(dt.getFullYear() - n);
    return dt;
}

export const AppContextProvider = ({ children }) => {
  
  let center = [-99, 40.5];

  const [user, setUser] = useState();
  const mapCenterRef = useRef(center);
  const mapZoomRef = useRef(3.5);
  const mapboxRef = useRef();
  const drawRef = useRef();
  const ctrlRef = useRef(new CustomControl());
  const [notifications, setNotifications] = useState([]);

  // TODO should not be in high level context
  const [selectedCorelogic, setSelectedCorelogic] = useState();
  const [loadingCorelogic, setLoadingCorelogic,] = useState(false);
  const [highlighted, setHighlighted] = useState([]);
  const [filters, setFilters] = useState({
    acres: [0, 9], // exponents of 10
    dates: [getYearsAgo(2), new Date()],
  });
  const [selected, setSelected] = useState();

  const notify = (txt, subtxt, icon) => {
    const id = uuidv4();
    setNotifications(ns => [...ns, {id, txt, subtxt, icon}])
    setTimeout(() => {
      setNotifications(ns => ns.filter(n => n.id !== id))
    }, 3000)
  }

  const [sideBarState, sideBarDispatch] = useReducer(sideBarReducer, {
    bigRightBar: false, showing: {}
  });
  // const [showing, setShowing] = useState({});
  // const [bigRightBar, setBigRightBar] = useState(false);

  const showing = sideBarState.showing;
  const bigRightBar = sideBarState.bigRightBar;

  const toggleBigRightBar = () => sideBarDispatch({ type: 'toggleBigRightBar' });
  const toggleShowing = (key, val) => sideBarDispatch({ type: 'toggleShowing', key, val})

  // Listen to the Firebase Auth state and set the local state.
  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(gUser => {
      if (gUser && gUser.email.endsWith('acretrader.com')) {
        setUser(gUser);
      }
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

	return <AppContext.Provider value={{
		user, setUser,
    mapCenterRef,
    mapZoomRef,
    mapboxRef,
    drawRef,
    ctrlRef,
    showing, toggleShowing,
    bigRightBar, toggleBigRightBar,
    notifications, setNotifications,
    notify,
    highlighted, setHighlighted,
    filters, setFilters,
    selected, setSelected,
    selectedCorelogic, setSelectedCorelogic,
    loadingCorelogic, setLoadingCorelogic,
	}} >
		{children}
	</AppContext.Provider>
}

